/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'getSystemById',
  message: messages.SUCCESS_GET_SYSTEM_BY_ID,
  method: 'GET',
  path: '/system/:objectId',
  payloadType: 'resource',
  requestSchema: requestSchemas.systems.getSystemById,
}];
